import { min } from "mathjs";
import type {
  AnnualConst,
  FirstRunValues,
  InitialData,
  NumberMatrix,
} from "../algorithm.types";

type FirstRunOperationsParams = {
  annualConst: Pick<AnnualConst, "annualTechGen"> & { annualDemand: number };
  sliderValues: Array<number>;
  reservesAvali: NumberMatrix;
  initialData: Pick<InitialData, "optionsData">;
};

export default function firstRunOperations({
  annualConst,
  sliderValues,
  reservesAvali,
  initialData,
}: FirstRunOperationsParams): FirstRunValues {
  return {
    firstRun: false,
    annualTechGenOriginal: annualConst.annualTechGen,
    annualDemandOriginal: annualConst.annualDemand,
    totalAnnualCarbonOriginal: initialData.optionsData.comparisonEmission,
    totalAnnualCostOriginal: initialData.optionsData.comparisonWholesaleCost,
    originalSliderValues: sliderValues,
    originalReserves: min(reservesAvali),
  };
}
